import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../../shared/shared.module';
import {ClearCartGuard} from '../../core/guards/clear-cart.guard';
import {ComboModifier} from 'src/app/routes/item/combo-modifier.module';
import {CategoryGroupListPage} from './category-group-list';
import {StoreGuard} from '../../core/guards/store.guard';
import {ItemRouteModule} from '../../routes/item/item.route';

@NgModule({
    declarations: [CategoryGroupListPage],
    imports: [
        SharedModule,
        ComboModifier,
        ItemRouteModule,
        RouterModule.forChild([
            {
                path: '',
                children: [
                    {
                        path: '',
                        component: CategoryGroupListPage,
                        canDeactivate: [ClearCartGuard],
                        canActivate: [StoreGuard]
                    },
                    {
                        path: 'item-grid',
                        loadChildren: '../item-grid/item-grid.module#ItemGridModule',
                        data: { preload: true, delay: true }
                    },
                    // {
                    //     path: 'multi-step-combo',
                    //     canActivate: [ItemGuard],
                    //     loadChildren: '../../routes/item/multi-step-combo/multi-step-combo.module#MultiStepComboModule'
                    // }
                ]
            },

        ])
    ]
})
export class CategoryGroupListModule {
}
